require('./e3plan-panel.scss');

import FloorplanPreview from '../e3plan-preview/e3plan-preview';
import EventEmmiter from '../helpers/EventEmmiter';
import Select from './floor-select/floor-select';
import E3Tips from './tips/tips';
import {UNIT_MILLIMETER, FLOORPLAN_CONFIG_MAPPING} from 'a_root-folder/constants';

const cloneDeep = require('lodash/cloneDeep');
const tipsImages = `${window.location.origin}/assets/global/img/tips`;

export default class FloorplanPanel extends EventEmmiter {

    _wrapper = null;
    _controls = {};
    _details = {};
    _shown = false;
    _preview = {};
    _floors = {};
    // _inputs = ['ceiling'];
    _inputs = [];
    _currentState = {};
    min_height_lens =100;


    constructor(container, config = {}, editable, e3plan_max_floors, metrical, actions) {
        super();
        this._config = cloneDeep(config);
        this._container = container;
        this._editable = editable;
        this._e3plan_max_floors = e3plan_max_floors;
        this.metrical = metrical;
        const {recreateFloorplan, recreateCurrentFloor} = actions;
        this._recreateFloorplan = recreateFloorplan;
        this._recreateCurrentFloor = recreateCurrentFloor;
        this._init();
    }

    _bindControlListeners(name) {
        let control = this._controls[name];
        if (!control) return;
        for (let i in control.events) {
            if (control.events.hasOwnProperty(i)) {
                control.element.addEventListener(i, control.events[i]);
            }
        }
    }

    updateControllsValue(name, value) {
        this._controls[name].value = value;
    }

    _destroyControl(name) {
        this._unbindControlListeners(name);
        this._controls[name].element.parentElement.removeChild(this._controls[name].element);
        delete this._controls[name];
    }

    _init() {
        this._wrapper = document.createElement('div');
        this._wrapper.classList.add('e3plan-panel');

        this._wrapper.innerHTML = require('./e3plan-panel.html');
        this._container.appendChild(this._wrapper);
        this._autoSaving = this._container.querySelector('.e3plan-panel__help_auto-saving');

        this._initTips();
        this._initDetails();
        this._initControls();
        this._initPreview();

    }

    showAutoSaving() {
        this._autoSaving.innerText = 'Saving';
    }

    hideAutoSaving() {
        this._autoSaving.innerText = '';
    }

    errorAutoSaving(err) {
        const div = document.createElement('div');
        const span = document.createElement('span');
        span.classList.add('e3plan-panel__header__err_msg');
        span.innerText = 'Saving error';
        const button = document.createElement('button');
        button.classList.add('e3plan-panel__header__btn');
        button.addEventListener('click', () => {
            this._fireEvent('debounce.save.plan');
        })
        button.innerHTML = '<i class="fa fa-refresh" aria-hidden="true"></i>';

        div.appendChild(span);
        div.appendChild(button);

        this._autoSaving.innerText = '';
        this._autoSaving.appendChild(div);
    }

    _initControl({name, element, event = 'click', callback = () => true}) {
        let control = {
            value: false,
            element,
            events: {}
        };

        control.events[event] = callback;

        this._controls[name] = control;
        this._bindControlListeners(name);
    }


    _initControls() {
        let addRemove = this._container.querySelector('.e3plan-panel__header__btn');
        let addReset = this._container.querySelector('.e3plan-panel__header__btn_reset');
        let helpBtn = this._container.querySelector('.e3plan-panel__help');
        this._initControl({
            name: 'add',
            element: addRemove,
            event: 'click',
            callback: this._toggleControl.bind(this, 'add', true)
        });
        this._initControl({
            name: 'reset',
            element: addReset,
            event: 'click',
            callback: this._toggleControl.bind(this, 'reset', true)
        });
        this._initControl({
            name: 'help',
            element: helpBtn,
            event: 'click',
            callback: this._toggleAvailability.bind(this)
        })
    }

    _initDetails() {

        // Init selects that present in config
        // Be aware that config related to ids inside panel template!
        for (let opt in this._config) {
            if (this._config.hasOwnProperty(opt)) {
                let el = this._container.querySelector(`#e3plan-panel-${opt}`);
                if (!el) continue;

                let input = this._container.querySelector(`[name=${el.name}-value]`);
                if (opt === 'floors') {
                    this._floors = new Select(el, {
                        options: this._config[opt]
                    }, this._e3plan_max_floors);

                    this._floors.on('toggle.layer.manager', this._onToggleLayerManager.bind(this));
                    this._floors.on('select.change', this._onFloorChange.bind(this));
                    this._floors.on('select.edit', this._onFloorEdit.bind(this));
                    this._floors.on('select.delete', this._onFloorDelete.bind(this));

                    continue;
                }

                // if (!this._config[opt].filter(val => val.id == -1).length) {
                //     el.options[0] = new Option('Custom', '-1', true, true);
                // }
                //
                // this._config[opt].forEach((item, i) => {
                //     let defaultSelected = false;
                //     let selected = false;
                //     if (item.id == -1) {
                //         defaultSelected = true;
                //         selected = true;
                //     }
                //     el.options[el.options.length] = new Option(item.name, item.id, defaultSelected, selected);
                //     //el.options[el.options.length] = new Option(item.name, item.id, false, item.selected);
                // });
                //
                // this._initControl({
                //     name: `change-${opt}`,
                //     element: el,
                //     event: 'change',
                //     callback: this._onSelectChanged.bind(this, opt, el)
                // });

                if (input) {
                    this._initControl({
                        name: `change-${opt}-value`,
                        element: input,
                        event: 'input',
                        callback: this._onInputChanged.bind(this, opt, input)
                    })
                }
                this._details[opt] = {};
                this._details[opt].input = input;
                this._details[opt].select = el;
            }
        }

        // Init inputs from local list
        // Be aware that local list names related to ids inside panel template!
        this._inputs.forEach(name => {
            let input = this._container.querySelector(`input[name=e3plan-panel-${name}-value]`);

            this._initControl({
                name: `change-${name}-value`,
                element: input,
                event: 'input',
                callback: this._onInputChanged.bind(this, name)
            });

            this._details[name] = {};
            this._details[name].input = input;
        });

    }

    _initPreview() {
        let previewContainer = this._container.querySelector('.e3plan-panel__preview');
        let iframeContainer = previewContainer.querySelector('.e3plan-panel__preview__container');
        let previewBtn = previewContainer.querySelector('.e3plan-panel__expand');

        previewBtn.disabled = true;
        this._preview._fullScreenBtn = previewBtn;
        this._preview.planPreview = new FloorplanPreview(iframeContainer, this._editable, {
            type: '2d',
            metrical: this.metrical
        });

        this._preview.planPreview.on('update', (plan) => this._onUpdate(plan));
        this._preview.planPreview.on('save.plan', (plan) => this._onSavePlan(plan));
        this._preview.planPreview.on('update.plan', () => this._onUpdatePlan());
        this._preview.planPreview.on('disabled', (disabled) => previewBtn.disabled = disabled);
        this._preview.planPreview.on('full.screen', (e) => {
            this._fireEvent('full.screen', e);
        });
        this._preview.planPreview.on('e3.planner.removeLayer', (id) => {
            this._fireEvent('remove.layer', id, true);
        });
        this._preview.planPreview.on('e3.planner.remove.hole', (id) => {
            this._fireEvent('remove.hole', id, true);
        });
        this._preview.planPreview.on('e3.planner.change.floors', (id) => {
            this._fireEvent('change.floors', id, true);
        });
        this._preview.planPreview.on('e3.planner.remove.area', (id) => {
            this._fireEvent('remove.area', id);
        });
        this._preview.planPreview.on('e3.planner.addLayer', (value, prevLayerId) => {
            if (this._floors.getFloorsCount() < this._e3plan_max_floors) {
                this._fireEvent('add.layer', value, prevLayerId, false);
            } else {
                this._fireEvent('upgrade.plan', {plans: this._floors._options.length});
            }
        });
        this._preview.planPreview.on('e3.planner.selectLayer', (id) => {
            this._fireEvent('select.layer', id);
        });
        this._preview.planPreview.on('e3.planner.helpModal', (id) => {
            this._fireEvent('e3.planner.helpModal', id);
        });
        this._preview.planPreview.on('e3.planner.set.layer.properties', (data) => {
            this._floors.onRenameFloor(data);
            this._fireEvent('set.layer.properties', data);
        });
        this._preview.planPreview.on('e3.planner.update.scene.properties', (data) => {
            this._fireEvent('e3.planner.update.scene.properties', data);
        });
        this._preview.planPreview.on('e3.planner.change.fontSize.layer', (data) => {
            this._fireEvent('e3.planner.change.fontSize.layer', data);
        });
        this._preview.planPreview.on('e3.planner.update.scene.color.properties', (data) => {
            this._fireEvent('e3.planner.update.scene.color.properties', data);
        });
        this._preview.planPreview.on('e3.planner.set.floor.params', (data) => {
            this._fireEvent('e3.planner.set.floor.params', data);
        });
        this._preview.planPreview.on('ready', () => {
            this._preview.planPreview.off('ready');
            this._fireEvent('ready')
        });

        this._preview.planPreview.on('show.3d', () => this._fireEvent('show.3d'));

        previewBtn.onclick = () => this._preview.planPreview.togglePreviewMode();

        this._preview._container = previewContainer;
    }

    isPreviewModeReadOnly() {
        return this._preview.planPreview.isReadOnly();
    }

    togglePreviewMode() {
        this._preview.planPreview.togglePreviewMode();
    }

    getPreview() {
        return this._preview.planPreview;
    }

    _initTips() {
        this._tips = new E3Tips(this._wrapper, {
            steps: {
                '1': {
                    text: 'Click on a floor or ceiling corner. ',
                    img: `${tipsImages}/1.jpg`
                },
                '2': {
                    text: 'Click on the next corner until you arrive back to the first one.Tap and hold the previous red dot to reposition it.',
                    img: `${tipsImages}/2.jpg`
                },
                '3': {
                    text: ' Adjust the height by dragging the red dots on the ceiling/floor wire frame if necessary. Go to the next room when done. ',
                    img: `${tipsImages}/3.jpg`
                },
                '4': {
                    text: ' Click the "HELP" button for video tutorials. ',
                    img: `${tipsImages}/3.jpg`
                }
            }
        });
    }

    _onFloorChange(e) {
        // in case of floorplan select
        if (e.id === '-1') {
            if (this._floors.getFloorsCount() < this._e3plan_max_floors) {
                this._fireEvent('add.floor', {prev: e.prev});
            } else {
                this._fireEvent('upgrade.plan', {plans: this._floors._options.length});
            }

            return;
        }

        this._fireEvent('change.floor', e);
    }

    _onToggleLayerManager(e) {
        this._preview.planPreview.toggleLayerManagerMode()
    }

    _onFloorDelete(e) {
        this._fireEvent('delete.floor', e.id);
    }

    _onFloorEdit(e) {
        this._fireEvent('edit.floor', e);
    }

    _onInputChanged(opt) {
        this._recreateCurrentFloor()
            .then(() => {
                let select = this._details[opt].select;
                if (select) {
                    select.value = '-1';
                }

                let value = this._getConfigValue(opt);
                if (value.id === '-1') {
                    this._updateCutomHeight(opt);
                    value = this._getConfigValue(opt);

                    if(value.height < this.min_height_lens) return ;
                }

                this._fireEvent('detail.save.cookie', {[opt]: value, custom: value.id === '-1'});
                this._saveFloorplanDetail(opt, true, true, true)
                this._currentState[opt] = {value: select.value, height: value.height}
            })
            .catch((e) => {
                let {height} = this._currentState[opt];
                this._details[opt].input.value = height;
            })
    }

    _updateCutomHeight(opt) {
        this._config[opt].forEach((config) => {
            if (config.id === '-1') {
                config.height = this._details[opt].input ? parseInt(this._details[opt].input.value) : null;
            }
        })
    }

    minimize(scene) {
        this._preview.planPreview.minimize(scene)
    }

    _onSelectChanged(opt, el) {
        this._recreateCurrentFloor()
            .then(() => {
                let input = this._details[opt].input;
                let option = this._config[opt].find(c => c.id === el.value);
                if (input && this._details[opt].select) {
                    input.value = option ? option.height : input.value;
                }
                const value = this._getConfigValue(opt);
                this._fireEvent('detail.save.cookie', {[opt]: value, custom: value.id === '-1'});
                this._saveFloorplanDetail(opt, undefined, undefined, true);
                this._currentState[opt] = {value: el.value, height: value.height}
            })
            .catch((e) => {
                let {value} = this._currentState[opt];
                let input = this._details[opt].input;
                let option = this._config[opt].find(c => c.id === value);
                if (input && this._details[opt].select) {
                    input.value = option ? option.height : input.value;
                }

                this._details[opt].select = el;
                this._details[opt].select.value = value;
                console.error(e);
            })
    }

    _onUpdate(plan) {
        this._fireEvent('update', plan);
    }

    _onSavePlan(plan) {
        this._fireEvent('save.plan', plan);
    }

    _onUpdatePlan() {
        this._fireEvent('update.plan');
    }

    _getConfigValue(opt, ignoreConfig = false) {
        let value = {};
        if (this._details[opt].select) {
            let fromConfig = ignoreConfig ? null : this._config[opt].find(item => item.id === this._details[opt].select.value);

            value = fromConfig ? fromConfig : {
                id: '-1',
                name: 'Custom',
                height: this._details[opt].input ? parseInt(this._details[opt].input.value) : null
            };
        } else {
            value = this._details[opt].input.value;
        }

        return value;
    }

    _saveFloorplanDetail(opt, isTopPoint = true, ignoreConfig = false, onchange=false) {
        let value = this._getConfigValue(opt, ignoreConfig);

        this._fireEvent('detail.save', {[FLOORPLAN_CONFIG_MAPPING[opt]]: value, isTopPoint, onchange});
    }

    _toggleAvailability(e) {
        e.preventDefault();
        this._fireEvent('e3.planner.help', {});
        // let helpBtn = this._container.querySelector('.e3plan-panel__help');

        // this._tips.toggleAvailability();
        // helpBtn.classList.toggle('help-active');
    }

    _toggleControl(name, val) {
        let control = this._controls[name];
        if (!control) return;
        control.value = typeof val !== 'undefined' ? val : !control.value;
        this._fireEvent(name, control.value);
    }

    _unbindControlListeners(name) {
        let control = this._controls[name];
        for (let i in control.events) {
            if (control.events.hasOwnProperty(i)) {
                control.element.removeEventListener(i, control.events[i]);
            }
        }
    }

    hideTipStep() {
        this._tips.cleanUpStep();
    }

    clearPreview() {
        if (this._preview.canvas) {
            this._preview.canvas.height = 0;
        }
    }

    destroy() {
        for (let i in this._controls) {
            if (this._controls.hasOwnProperty(i)) {
                this._destroyControl(i);
            }
        }
        this._container.removeChild(this._wrapper);
        this._preview.planPreview.off();
        this._preview.planPreview.destroy();
        this._tips.destroy();
        this._floors.destroy();
    }

    generatePreview(plan, clean, defaultPlan) {
        this._preview.planPreview.updatePlan(plan, null, clean, defaultPlan);
    }

    getControlValue(controlName) {
        return this._controls[controlName] ? this._controls[controlName].value : null;
    }

    hide() {
        this._wrapper.classList.add('hidden');
        this._shown = false;
    }

    hideControl(control) {
        if (!this._controls[control]) return;

        let {element} = this._controls[control];

        element.classList.add('hide');
    }

    setDetails(details, isTopPoint, noSetInput = false) {
        for (let opt in details) {
            if (details.hasOwnProperty(opt)) {
                if (this._config[opt]) {
                    let selectValue = this._config[opt].find(item => details[opt].id === item.id);
                    selectValue = selectValue ? selectValue : details[opt].id ? details[opt] : this._config[opt][0];

                    if (opt == 'floors') this._fireEvent('set.floor', Object.assign(details[opt], {isNeedMove: true}));
                    if (!this._details[opt]) continue;

                    if (this._details[opt].input && !noSetInput) {
                        this._details[opt].select.value = selectValue.id;
                        this._details[opt].input.value = parseInt(selectValue.height);
                        this._details[opt].input.nextElementSibling.innerText = UNIT_MILLIMETER;
                    } else {
                        this._details[opt].select.value = selectValue.id;
                    }
                    this._currentState[opt] = {value: selectValue.id, height: selectValue.height};

                    this._saveFloorplanDetail(opt, isTopPoint)
                } else {
                    if (!this._details[opt]) continue;
                    this._details[opt].input.value = Math.round(details[opt]);
                    this._saveFloorplanDetail(opt)
                }
            }
        }
    }

    setFloor(floor) {
        this._floors.setValue(floor.id);
    }

    getFloor() {
        return this._floors.getValue();
    }

    isShown() {
        return this._shown;
    }

    show(isNeedUpdateScene) {
        this._wrapper.classList.remove('hidden');
        if (isNeedUpdateScene) this._fireEvent('set.room', {});
        this._shown = true;
    }

    showControl(control) {
        if (!this._controls[control]) return;

        let {element} = this._controls[control];

        element.classList.remove('hide');
    }

    showTipsStep(key) {
        key = key.toString();
        this._tips.changeStep(key);
    }

    switchControl(controlName, value) {
        this._toggleControl(controlName, value);
    }

    updateFloors(floors, selected) {
        this._floors.reinitOptions(floors);
        this._floors.setValue(selected.id);
    }
}
